import { useState, useEffect } from "react";
import api from "../api";
import { useTheme } from "../components/Theme";

const ORANGE = "#E8520A";
const PACOTES = ["Starter R$550","Pro R$1.200","Avançado R$1.800","Premium R$2.800"];
const ORIGENS = ["Instagram","Google","Indicação","WhatsApp","Facebook","Site","Outro"];

function fmt(v) { return `R$${Number(v||0).toLocaleString("pt-BR")}`; }

function Badge({ color, children }) {
  return <span style={{ background:color+"22", color, border:`1px solid ${color}44`, borderRadius:6, fontSize:10, fontWeight:700, padding:"2px 8px", letterSpacing:".04em" }}>{children}</span>;
}

function Modal({ cliente, onClose, onSave, onDelete }) {
  const { theme } = useTheme();
  const isNew = !cliente?._id;
  const [form, setForm] = useState(cliente||{ nome:"",empresa:"",telefone:"",email:"",origem:"Instagram",pacote:"Pro R$1.200",valor:1200,obs:"",dataFechamento:new Date().toISOString().slice(0,10),vencimentoMensalidade:new Date().toISOString().slice(0,10) });
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));
  const inp={ width:"100%", boxSizing:"border-box", background:theme.bgInput, border:`1px solid ${theme.border}`, borderRadius:8, padding:"8px 10px", color:theme.text, fontSize:13, outline:"none", colorScheme:theme.name, fontFamily:"inherit" };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.7)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }} onClick={onClose}>
      <div style={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:16, padding:28, width:"100%", maxWidth:480, maxHeight:"90vh", overflowY:"auto" }} onClick={e=>e.stopPropagation()}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
          <h2 style={{ margin:0, fontSize:18, fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, letterSpacing:2, color:theme.text }}>{isNew?"NOVO CLIENTE":"EDITAR CLIENTE"}</h2>
          <button onClick={onClose} style={{ background:"none", border:"none", color:theme.textMuted, fontSize:22, cursor:"pointer" }}>×</button>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
          {[["Nome","nome"],["Empresa","empresa"],["Telefone","telefone"],["Email","email"]].map(([label,key])=>(
            <div key={key}>
              <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:4, letterSpacing:".04em", textTransform:"uppercase" }}>{label}</label>
              <input value={form[key]||""} onChange={e=>set(key,e.target.value)} style={inp} />
            </div>
          ))}
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12, marginBottom:12 }}>
          {[["Origem","origem",ORIGENS],["Pacote","pacote",PACOTES]].map(([label,key,opts])=>(
            <div key={key}>
              <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:4, letterSpacing:".04em", textTransform:"uppercase" }}>{label}</label>
              <select value={form[key]} onChange={e=>set(key,e.target.value)} style={{ ...inp, appearance:"auto" }}>
                {opts.map(o=><option key={o}>{o}</option>)}
              </select>
            </div>
          ))}
          <div>
            <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:4, letterSpacing:".04em", textTransform:"uppercase" }}>Valor (R$)</label>
            <input type="number" value={form.valor} onChange={e=>set("valor",e.target.value)} style={inp} />
          </div>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
          {[["Data de fechamento","dataFechamento"],["Vencimento mensalidade","vencimentoMensalidade"]].map(([label,key])=>(
            <div key={key}>
              <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:4, letterSpacing:".04em", textTransform:"uppercase" }}>{label}</label>
              <input type="date" value={form[key]||""} onChange={e=>set(key,e.target.value)} style={inp} />
            </div>
          ))}
        </div>
        <div style={{ marginBottom:20 }}>
          <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:4, letterSpacing:".04em", textTransform:"uppercase" }}>Observações</label>
          <textarea value={form.obs||""} onChange={e=>set("obs",e.target.value)} rows={2} style={{ ...inp, resize:"vertical" }} />
        </div>
        <div style={{ display:"flex", gap:10 }}>
          <button onClick={()=>onSave({...form,stage:"fechado"})} style={{ flex:1, background:"#10b981", border:"none", borderRadius:10, padding:"11px 0", color:"#fff", fontWeight:800, fontSize:14, cursor:"pointer", fontFamily:"'Barlow Condensed',sans-serif", letterSpacing:1 }}>SALVAR</button>
          {!isNew&&<button onClick={()=>onDelete(cliente._id)} style={{ background:"#ef444422", border:"1px solid #ef444444", borderRadius:10, padding:"11px 16px", color:"#ef4444", fontWeight:700, fontSize:13, cursor:"pointer" }}>Excluir</button>}
        </div>
      </div>
    </div>
  );
}

export default function Clientes() {
  const { theme } = useTheme();
  const [clientes, setClientes] = useState([]);
  const [modal, setModal]       = useState(null);
  const [search, setSearch]     = useState("");
  const [loading, setLoading]   = useState(true);

  const carregar = async () => {
    try { const { data } = await api.get("/leads?stage=fechado&limit=500"); setClientes(data.leads); } catch {} setLoading(false);
  };
  useEffect(() => { carregar(); }, []);

  const salvar = async (form) => {
    if (form._id) { const { data } = await api.put(`/leads/${form._id}`, form); setClientes(prev=>prev.map(c=>c._id===data._id?data:c)); }
    else { const { data } = await api.post("/leads", form); setClientes(prev=>[...prev,data]); }
    setModal(null);
  };
  const excluir = async (id) => { await api.delete(`/leads/${id}`); setClientes(prev=>prev.filter(c=>c._id!==id)); setModal(null); };

  const filtered = clientes.filter(c=>{const q=search.toLowerCase();return !q||c.nome?.toLowerCase().includes(q)||c.empresa?.toLowerCase().includes(q);});
  const mrr = clientes.reduce((a,c)=>a+Number(c.valor||0),0);
  const hoje = new Date();
  const vencendoEm7dias = clientes.filter(c=>{if(!c.vencimentoMensalidade)return false;const diff=(new Date(c.vencimentoMensalidade)-hoje)/(1000*60*60*24);return diff>=0&&diff<=7;});

  return (
    <div style={{ padding:24, fontFamily:"'Barlow',sans-serif", background:theme.bg, minHeight:"100vh" }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20, flexWrap:"wrap", gap:12 }}>
        <div>
          <h2 style={{ margin:0, fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:22, letterSpacing:2, color:theme.text }}>CLIENTES ATIVOS</h2>
          <p style={{ margin:"4px 0 0", fontSize:13, color:theme.textMuted }}>{clientes.length} clientes · MRR {fmt(mrr)}</p>
        </div>
        <button onClick={()=>setModal({})} style={{ background:"#10b981", border:"none", borderRadius:8, padding:"8px 20px", color:"#fff", fontWeight:800, fontSize:13, cursor:"pointer", fontFamily:"'Barlow Condensed',sans-serif", letterSpacing:1 }}>+ NOVO CLIENTE</button>
      </div>

      {vencendoEm7dias.length>0 && (
        <div style={{ background:"#f59e0b18", border:"1px solid #f59e0b44", borderRadius:10, padding:"10px 16px", marginBottom:16, fontSize:13, color:"#f59e0b" }}>
          ⚠️ {vencendoEm7dias.length} mensalidade{vencendoEm7dias.length>1?"s vencem":"vence"} nos próximos 7 dias: {vencendoEm7dias.map(c=>c.nome).join(", ")}
        </div>
      )}

      <div style={{ marginBottom:16 }}>
        <input placeholder="🔍 Buscar cliente..." value={search} onChange={e=>setSearch(e.target.value)}
          style={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:8, padding:"8px 14px", color:theme.text, fontSize:13, outline:"none", width:260, colorScheme:theme.name }} />
      </div>

      {loading ? <div style={{ color:theme.textMuted, textAlign:"center", padding:40 }}>Carregando...</div> : (
        <div style={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:12, overflow:"hidden", boxShadow:theme.name==="light"?"0 1px 4px rgba(0,0,0,.06)":"none" }}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 120px 140px 130px 80px", padding:"10px 16px", background:theme.bgInput, fontSize:11, color:theme.textMuted, letterSpacing:".04em", textTransform:"uppercase", fontWeight:600 }}>
            <span>Cliente</span><span>Empresa</span><span>Pacote</span><span>Origem</span><span>Vencimento</span><span>Valor</span>
          </div>
          {filtered.length===0&&<div style={{ textAlign:"center", padding:40, color:theme.textMuted, fontSize:13 }}>Nenhum cliente encontrado.</div>}
          {filtered.map((c)=>{
            const venc=c.vencimentoMensalidade?new Date(c.vencimentoMensalidade):null;
            const diff=venc?(venc-hoje)/(1000*60*60*24):999;
            const vencColor=diff<0?"#ef4444":diff<=7?"#f59e0b":theme.textMuted;
            return (
              <div key={c._id} onClick={()=>setModal(c)} style={{ display:"grid", gridTemplateColumns:"1fr 1fr 120px 140px 130px 80px", padding:"12px 16px", borderTop:`1px solid ${theme.border}`, cursor:"pointer" }}
                onMouseEnter={e=>e.currentTarget.style.background=theme.bgInput}
                onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                <span style={{ color:theme.text, fontWeight:600, fontSize:13 }}>{c.nome}</span>
                <span style={{ color:theme.textMuted, fontSize:13 }}>{c.empresa||"—"}</span>
                <span><Badge color="#10b981">{c.pacote?.split(" ")[0]}</Badge></span>
                <span><Badge color="#6366f1">{c.origem}</Badge></span>
                <span style={{ color:vencColor, fontSize:12 }}>{venc?venc.toLocaleDateString("pt-BR"):"—"}</span>
                <span style={{ color:ORANGE, fontWeight:700, fontSize:13 }}>{fmt(c.valor)}</span>
              </div>
            );
          })}
          {filtered.length>0&&(
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 120px 140px 130px 80px", padding:"10px 16px", borderTop:`1px solid ${theme.border}`, background:theme.bgInput }}>
              <span style={{ color:theme.textMuted, fontSize:12, gridColumn:"span 5" }}>Total</span>
              <span style={{ color:"#10b981", fontWeight:800, fontSize:14 }}>{fmt(filtered.reduce((a,c)=>a+Number(c.valor||0),0))}</span>
            </div>
          )}
        </div>
      )}
      {modal!==null&&<Modal cliente={Object.keys(modal).length?modal:null} onClose={()=>setModal(null)} onSave={salvar} onDelete={excluir} />}
    </div>
  );
}
